<template>
    <sui-tab-pane class="tab-pane" :title="title" :label="data.length.toString()" :attached="false">
        <simple-table :data="data" :columns="stColumns" :stretch="true" :show-row-numbers="true"  :selectable="true" :num-rows="999"/>
    </sui-tab-pane>
</template>

<script>
  import SimpleTable from "../../simple-table/SimpleTable";
  export default {
    name: "CacheClients",
    components: {SimpleTable},
    props: ["data", "title"],
    data: function() {
      return {
        stColumns: [
          {header: "id", field: "ID", format: "number"},
          {header: "Name", field: "DeviceName"},
          {header: "Owner", field: "Owner"},
          {header: "ElevatedAccess", field: "ElevatedAccess", format: "bool"},
          {header: "DeviceID", field: "DeviceID"},
          {header: "Created", field: "Created", format: "dateTime"},
          {header: "LastLogin", field: "LastLogin", format: "dateTime"},
          {header: "LastAccess", field: "LastAccess", format: "dateTime"},
        ],
      }
    },
  }
</script>

<style scoped>
    .tab-pane {
        margin-top: 10pt;
        border: 0;
        border-top: 1px solid #E0E0E0;
        box-shadow: initial;
    }

</style>